import React from "react";

const clampStyle = {
  display: "-webkit-box",
  WebkitBoxOrient: "vertical",
  WebkitLineClamp: 3,
  overflow: "hidden",
};

/** Overlay on fuel form image thumbnails (time in 24h, lat/long, address). */
export const FuelImageMetadataOverlay = ({
  capturedAt,
  latitude,
  longitude,
  address,
}) => {
  const hasAddress = address && address !== "-" && address !== "—";
  const hasMeta = capturedAt || latitude || longitude || hasAddress;
  if (!hasMeta) return null;

  return (
    <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/85 via-black/55 to-transparent px-3 pb-3 pt-12">
      {hasAddress ? (
        <p
          className="text-sm font-UbuntuMedium leading-snug text-white drop-shadow"
          title={address}
          style={clampStyle}
        >
          {address}
        </p>
      ) : null}
      {capturedAt ? (
        <p className="mt-1 text-xs leading-snug text-white/95 drop-shadow">
          {capturedAt}
        </p>
      ) : null}
      {latitude || longitude ? (
        <p className="mt-1 text-xs leading-snug text-white/95 drop-shadow">
          {latitude ? `Lat: ${latitude}` : ""}
          {latitude && longitude ? ", " : ""}
          {longitude ? `Long: ${longitude}` : ""}
        </p>
      ) : null}
    </div>
  );
};

/** Expanded metadata below image in lightbox modal. */
export const FuelImageMetadataPanel = ({
  capturedAt,
  latitude,
  longitude,
  address,
}) => {
  const hasAddress = address && address !== "-" && address !== "—";
  const hasMeta = capturedAt || latitude || longitude || hasAddress;
  if (!hasMeta) return null;

  return (
    <div className="min-w-0 rounded-b-xl bg-white p-3 space-y-2 max-[767px]:overflow-auto">
      {hasAddress ? (
        <div>
          <p className="mb-0.5 text-sm font-UbuntuMedium text-gray-500">Address</p>
          <p className="mb-0 whitespace-normal break-words text-sm leading-relaxed text-gray-800">
            {address}
          </p>
        </div>
      ) : null}
      {capturedAt ? (
        <div>
          <p className="mb-0.5 text-sm font-UbuntuMedium text-gray-500">Date &amp; Time</p>
          <p className="mb-0 whitespace-normal break-words text-sm leading-relaxed text-gray-800">
            {capturedAt}
          </p>
        </div>
      ) : null}
      {latitude || longitude ? (
        <div>
          <p className="mb-0.5 text-sm font-UbuntuMedium text-gray-500">Latitude &amp; Longitude</p>
          <p className="mb-0 whitespace-normal break-words text-sm leading-relaxed text-gray-800">
            {latitude ? `Lat: ${latitude}` : ""}
            {latitude && longitude ? ", " : ""}
            {longitude ? `Long: ${longitude}` : ""}
          </p>
        </div>
      ) : null}
    </div>
  );
};

export const buildFuelFormImageMeta = (d, formatDateTimeFn) => {
  const address = (d?.full_address || "").trim();
  const capturedAt = formatDateTimeFn(d?.createdAt, "");
  const latitude =
    d?.latitude != null && String(d.latitude).trim() !== "" ? String(d.latitude) : "";
  const longitude =
    d?.longitude != null && String(d.longitude).trim() !== "" ? String(d.longitude) : "";

  return { capturedAt, latitude, longitude, address };
};
